import script from "./DropletDimensionInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropletDimensionInputs.vue?vue&type=script&setup=true&lang=ts"

import "./DropletDimensionInputs.vue?vue&type=style&index=0&id=c197ff2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c197ff2c"]])

export default __exports__